import { Box } from '@mui/material'
import { useGridFilter } from 'ag-grid-react'
import { intl } from '../../../../../../../../../i18n'
import { DetailFilter } from './useDetailFilter'

type DetailCellFilterModel = DetailFilter[]

interface DetailCellFilterProps {
  colDef?: {
    cellRendererParams?: {
      openComment?: boolean
    }
  }
  model: DetailCellFilterModel | null
  onModelChange: (model: DetailCellFilterModel | null) => void
}

const ALL_VALUES = [DetailFilter.HAS_COMMENT, DetailFilter.NO_COMMENT]

const buildModel = (values: DetailFilter[]): DetailCellFilterModel | null => {
  const isFiltered = values.length < ALL_VALUES.length
  return isFiltered ? values : null
}

export const DetailCellFilter = (props: DetailCellFilterProps) => {
  const values: DetailFilter[] = props.model ?? ALL_VALUES

  const doesFilterPass = params => {
    // Don't filter new rows
    if (params.data.isAdded) return true
    if (!props.model) return true
    if (props.model.length === 0) return false
    const commentSummary =
      params.data.commentSummary ?? params.data.body?.commentSummary
    const hasComment = commentSummary?.hasComment ?? false
    return (
      (props.model.includes(DetailFilter.HAS_COMMENT) && hasComment) ||
      (props.model.includes(DetailFilter.NO_COMMENT) && !hasComment)
    )
  }

  useGridFilter({ doesFilterPass })

  const onChange = (key: DetailFilter, checked: boolean) => {
    if (checked) {
      props.onModelChange(buildModel([...values, key]))
    } else {
      props.onModelChange(buildModel(values.filter(v => v !== key)))
    }
  }

  return (
    <Box sx={{ minHeight: 100, padding: '2px' }}>
      {props.colDef?.cellRendererParams?.openComment && (
        <>
          <FilterCheckBox
            option={DetailFilter.HAS_COMMENT}
            checked={values.includes(DetailFilter.HAS_COMMENT)}
            label={intl.formatMessage({ id: 'openDetail.hasComment' })}
            onChange={e => onChange(DetailFilter.HAS_COMMENT, e.target.checked)}
          />
          <FilterCheckBox
            option={DetailFilter.NO_COMMENT}
            checked={values.includes(DetailFilter.NO_COMMENT)}
            label={intl.formatMessage({ id: 'openDetail.noComment' })}
            onChange={e => onChange(DetailFilter.NO_COMMENT, e.target.checked)}
          />
        </>
      )}
    </Box>
  )
}

type FilterCheckBoxProps = {
  option: DetailFilter
  checked: boolean
  label: string
  onChange: (e) => void
}

const FilterCheckBox = ({
  option,
  checked,
  label,
  onChange,
}: FilterCheckBoxProps) => {
  return (
    <CheckBoxItem key={`detail-filter-${option}`}>
      <FilterInput
        key={`detail-filter-${option}-checkbox`}
        checked={checked}
        onChange={onChange}
      />
      <FilterCheckBoxLabel htmlFor={`detail-filter-${option}-checkbox`}>
        {label}
      </FilterCheckBoxLabel>
    </CheckBoxItem>
  )
}

const CheckBoxItem = ({ children }) => (
  <div style={{ height: 23 }}>{children}</div>
)

const FilterInput = ({ checked, onChange }) => (
  <input
    type="checkbox"
    style={{
      width: 15,
      height: 15,
      color: '#0091ea',
      backgroundColor: '#ffffff',
      verticalAlign: 'middle',
    }}
    checked={checked}
    onChange={onChange}
  />
)

const FilterCheckBoxLabel = ({ children, htmlFor }) => (
  <label style={{ verticalAlign: 'middle' }} htmlFor={htmlFor}>
    {children}
  </label>
)
